const ORIENTATION_TO_ANGLE = {
  '3': 180,
  '6': 90,
  '8': -90,
};

export {
  ORIENTATION_TO_ANGLE
};